<script lang="ts" setup>
import PageLink from '@/pages/hence/components/PageLink.vue'
import Side from '@/pages/hence/components/Side.vue'
import Content from './components/Content.vue'
import Ad from '@/pages/hence/components/Ad.vue'
import List from './components/List.vue'
import Newsletter from '@/pages/hence/components/Newsletter.vue'
import { useArticleStore } from '@/stores'
import type { IHomeHenceCard } from '@/utils/types'
import useSeo from './seo'

const { advert } = useApi()
const route = useRoute()
const articleId = route.params.id as string
const articleStore = useArticleStore()
await articleStore.fetchArticleCategories('projectCategories', {
  className: 'articleProject'
})
await articleStore.fetchArticleRecipe(articleId)
const article = computed(() => articleStore.recipe)
const recommends = computed(() => articleStore.recommends.map((item) => {
  return {
    image: item.image,
    category: item.categories.length > 0 ? item.categories[0].subject : '',
    title: item.subject,
    link: `/hence/recipe/article/${item.id}`
  } as IHomeHenceCard
}))

onMounted(() => {
  nextTick(() => {
    articleStore.fetchArticleRecommends(articleId)
  })
})

const { data: advertData } = await advert.getAdvert('recipe-detail')
const advertRes = computed(() => advertData.value?.data)

useSeo(article.value)
</script>

<template>
  <section class="hence">
    <div class="hence__pageLink">
      <PageLink />
    </div>
    <div class="hence__sideBox">
      <Side class="hence__side" category-name="恆食堂" />
    </div>
    <Content class="hence__content" :data="article" />
    <Ad class="hence__ad" :data="advertRes" v-if="advertRes" />
    <List :items="recommends" class="hence__list" />
    <Newsletter class="hence__full" />
  </section>
</template>

<style lang="scss" scoped>
.hence {
  @include grid;

  @include max-media(1180) {
    @include grid(4, 24);
  }

  @include max-media(767) {
    position: relative;
    z-index: 2;
    transform: translateY(toRem(100));
    margin-top: toRem(-100);
  }

  &__pageLink {
    grid-column: 1 / span 4;

    @include min-media(1181) {
      display: none;
    }
  }

  &__sideBox {
    display: flex;
    justify-content: flex-end;
    grid-column: 1 / span 2;

    @include max-media(1180) {
      display: none;
    }
  }

  &__side {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    max-height: 90vh;
    overflow-y: auto;
  }

  &__content {
    grid-column: 4 / span 8;
    margin-bottom: toRem(200);

    @include max-media(1180) {
      grid-column: 1 / span 4;
    }

    @include max-media(767) {
      margin-bottom: toRem(50);
    }
  }

  &__ad {
    grid-column: 1 / span 12;

    @include max-media(1180) {
      grid-column: 1 / span 4;
    }
  }

  &__list {
    grid-column: 1 / span 12;

    @include max-media(1180) {
      grid-column: 1 / span 4;
    }
  }

  &__full {
    position: relative;
    z-index: 2;
    margin-left: toRem(-24);
    margin-right: toRem(-24);
    grid-column: 1 / span 12;

    @include max-media(1180) {
      grid-column: 1 / span 4;
    }
  }
}
</style>
